import { computed, ref, Ref } from "vue";
import { Client } from "../../domain/clients";

const emptyArtwork: Client = {
  clientId: "",
  identificationType: "",
  identificationNumber: "",
  company: "",
  contactName: "",
  contactEmail: "",
  contactPhone: 0,
  billingEmail: "",
  isSameEmail: false,
};

const memoryClient: Ref<Client> = ref(emptyArtwork);

export function clientStore() {
  async function updateClientSession(newClient: Client) {
    memoryClient.value = newClient;
  }

  function reset(): void {
    memoryClient.value = emptyArtwork;
  }

  function matchClient(clientId: string): boolean {
    return clientId === memoryClient.value.clientId;
  }

  const isEmpty = computed(() => {
    return memoryClient.value.clientId === emptyArtwork.clientId;
  });

  return {
    updateClientSession,
    isEmpty,
    memoryClient: memoryClient.value,
    reset,
    matchClient,
  };
}
